import React from 'react';
import styles from './PressSection.module.css';

type PressLogo = {
	href: string;
	src: string;
	alt: string;
	ariaLabel?: string;
};

const CDN_BASE = 'https://turtl-web-images.azureedge.net/website/';

const PRESS_LOGOS: PressLogo[] = [
	{
		href: 'https://www.instagram.com/reels/DL3DtAYtD1K/',
		src: `${CDN_BASE}TODAY-logo-black.png`,
		alt: 'TODAY',
		ariaLabel: 'Watch the TODAY feature'
	},
	{
		href: 'https://www.cbsnews.com/minnesota/news/turtle-tracking-app-minnesota/',
		src: `${CDN_BASE}CBS_logo.png`,
		alt: 'CBS News Minnesota',
		ariaLabel: 'Read on CBS News Minnesota'
	},
	{
		href: 'https://www.kare11.com/video/news/local/sisters-create-app-to-track-turtle-safety/89-40b81ce5-2513-4b02-b191-0fe987ca9698',
		src: `${CDN_BASE}Kare-11-black.png`,
		alt: 'KARE 11',
		ariaLabel: 'Watch on KARE 11'
	},
	{
		href: 'https://kstp.com/special-coverage/minnesota-live/turtletracker/',
		src: `${CDN_BASE}MN-live-black.png`,
		alt: 'Minnesota Live (KSTP)',
		ariaLabel: 'View Minnesota Live coverage'
	},
	{
		href: 'https://mspmag.com/arts-and-culture/helping-turtles-cross-the-road/',
		src: `${CDN_BASE}mpls.png`,
		alt: 'Mpls.St.Paul Magazine',
		ariaLabel: 'Read on Mpls.St.Paul Magazine'
	},
	{
		href: 'https://www.mprnews.org/story/2025/06/02/turtle-road-crossings-helped-with-app-by-minnesota-sisters',
		src: `${CDN_BASE}mpr.png`,
		alt: 'MPR News',
		ariaLabel: 'Read on MPR News'
	},
	{
		href: 'https://www.podbean.com/media/share/pb-uub94-18cc981?action=openEpisode',
		src: `${CDN_BASE}mnbound.png`,
		alt: 'Minnesota Bound Podcast',
		ariaLabel: 'Listen on Minnesota Bound Podcast'
	},
	{
		href: 'https://www.startribune.com/can-ai-save-turtles-these-minnesota-sisters-think-so/601320266',
		src: `${CDN_BASE}strib.png`,
		alt: 'Star Tribune',
		ariaLabel: 'Read on Star Tribune'
	}
];

const PressSection: React.FC = () => {
	return (
		<section className={styles.section} aria-labelledby="press-header">
			<div className={styles.wrapper}>
				<h2 id="press-header" className={styles.header}>
					In the press
				</h2>
				<div className={styles.logosGrid}>
					{PRESS_LOGOS.map(({ href, src, alt, ariaLabel }) => (
						<a
							key={href}
							href={href}
							target="_blank"
							rel="noopener noreferrer"
							className={styles.logoLink}
							aria-label={ariaLabel || alt}
						>
							<img className={styles.logoImg} src={src} alt={alt} />
						</a>
					))}
				</div>
			</div>
		</section>
	);
};

export default PressSection;
 